var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grades-list flickity-container"},[_c('flickity',{ref:"flickity",staticClass:"flickity carousel",attrs:{"options":_vm.flickityOptions},on:{"init":_vm.onInit}},_vm._l((_vm.grades),function(gradesList,gradesLabel){return _c('GradesItem',{key:gradesLabel,attrs:{"gradesLabel":gradesLabel,"grades":gradesList}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }